import dynamic from 'next/dynamic'
import React, { ForwardedRef, forwardRef } from 'react'
import { Carousel } from 'lib/Carousel'
import { useVisibleProductDrops } from '../queries/useVisibleProductDrops'
import { DropBannerPlaceholder } from './DropBanner'

const DropBanner = dynamic(() => import('./DropBanner').then((res) => res.DropBanner))

export const CurrentDropsCarousel = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
  const { data, loading } = useVisibleProductDrops()
  const hasMultipleDrops = (data?.productDrops ?? []).length > 1 ?? false

  return (
    <Carousel ref={ref} itemWidth={hasMultipleDrops ? 'calc(100% - 24px)' : '100%'}>
      {data?.productDrops.map((productDrop, ix) => (
        <DropBanner key={productDrop.id} withBackground productDrop={productDrop} lazyLoadImage={ix > 0} />
      ))}
      {(!data?.productDrops || loading) && <DropBannerPlaceholder key="drop-banner-placeholder" />}
    </Carousel>
  )
})

CurrentDropsCarousel.displayName = 'CurrentDropsCarousel'
